<template>
  <div :class="['home', { 'is-mobile': isMobile }]">
    <section class="first" ref="sec1">
      <div class="caption">
        <h2 class="title textfade textfade1">埃洛克航空</h2>
        <p class="text textfade textfade2">低空基础设施解决方案提供商</p>
      </div>
    </section>
    <section
      :class="['second', { active: activeSec > 1 }, { 'has-bg': hasBg }]"
      ref="sec2"
    >
      <img
        :src="
          require(`@/assets/image/home/${isMobile ? 'mobile/' : ''}p2-bg.webp`)
        "
        alt=""
        class="bg"
      />
      <h3 v-if="isMobile" :class="['textfade', { textfade1: activeSec > 1 }]">
        细分领域
      </h3>
      <ul class="list">
        <li
          v-for="(item, index) in feature"
          :key="index"
          @click="handleFeature(index)"
        >
          <img
            :src="require(`@/assets/image/home/v2/${item.url}.png`)"
            alt=""
            :class="['textfade', activeSec > 1 && `textfade${index + 2}`]"
          />
        </li>
      </ul>
    </section>

    <section class="three" ref="sec3">
      <img
        :src="
          require(`@/assets/image/home/v2/${
            isMobile ? 'mobile/' : ''
          }p3-bg.webp`)
        "
        alt=""
      />
      <div class="caption">
        <h3 :class="['textfade', { textfade1: activeSec > 2 }]">无人机装备</h3>
        <div class="top">
          <div
            class="gather"
            :class="['textfade', { textfade2: activeSec > 2 }]"
          >
            <h6>采集系统</h6>
            <div>
              <img
                :src="
                  require(`@/assets/image/home/v2/${
                    isMobile ? 'mobile/' : ''
                  }plane.webp`)
                "
                alt=""
                @click="changeRoute('/collector')"
              />
            </div>
          </div>
          <div
            class="module"
            :class="['textfade', { textfade3: activeSec > 2 }]"
          >
            <h6 v-if="!isMobile">模块支持系统</h6>
           <ul>
              <li @click="changeRoute('/AK1')">
                <img src="@/assets/image/home/v2/ak1.webp" alt="" />
              </li>
              <li @click="changeRoute('/AK2')">
                <img src="@/assets/image/home/v2/ak2.webp" alt="" />
              </li>
              <li @click="changeRoute('/AK3')">
                <img src="@/assets/image/home/v2/ak3.webp" alt="" />
              </li>
              <li @click="changeRoute('/c5')">
                <img src="@/assets/image/home/v2/c5.webp" alt="" />
              </li>
            </ul>
            <h6 v-if="isMobile">模块支持系统</h6>
          </div>
        </div>
        <div
          class="polling"
          :class="['textfade', { textfade4: activeSec > 2 }]"
        >
          <h6 v-if="!isMobile">侦查与巡检系统</h6>
          <ul>
            <li @click="changeRoute('/observer')"><img src="@/assets/image/home/v2/box.webp" alt="" /></li>
            <li @click="changeRoute('/catcher')"><img src="@/assets/image/home/v2/screen.webp" alt="" /></li>
          </ul>
          <h6 v-if="isMobile">侦查与巡检系统</h6>
        </div>
      </div>
    </section>
    <section class="four" ref="sec4">
      <h3 :class="['textfade', { textfade1: activeSec > 3 }]">行业应用</h3>
      <template v-if="!isMobile">
        <ul :class="['tabWrap textfade', { textfade2: activeSec > 3 }]">
          <li
            v-for="(item, index) in adhibition"
            :key="index"
            :class="['tabItem', { activeTab: index == activeCase }]"
            @click="activeCase = index"
          >
            {{ item.title }}
          </li>
        </ul>
        <div class="tabContent">
          <img
            :src="
              require(`@/assets/image/home/v2/${adhibition[activeCase].img}.png`)
            "
            alt=""
            :class="['textfade', { textfade3: activeSec > 3 }]"
          />
          <div class="right">
            <div :class="['subtitle textfade', { textfade4: activeSec > 3 }]">
              <h5>{{ adhibition[activeCase].subtitle }}</h5>
              <span @click="changeRoute('/service')">查看详情 ></span>
            </div>
            <ul :class="['list textfade', { textfade5: activeSec > 3 }]">
              <li
                v-for="(item, index) in adhibition[activeCase].content"
                :key="index"
              >
                <h6>{{ item.caption }}</h6>
                <p v-html="item.matter"></p>
              </li>
            </ul>
          </div>
        </div>
      </template>
      <template v-if="isMobile">
        <div
          class="menu_select swiper-container"
          :class="['textfade', { textfade2: activeSec > 3 }]"
        >
          <ul
            class="swiper-wrapper"
            :class="[
              { swiperFadeIn: swiperFadeType == 'swiperFadeIn' },
              { swiperFadeOut: swiperFadeType == 'swiperFadeOut' },
            ]"
          >
            <li
              id="slide"
              v-for="(item, index) in adhibition"
              :key="index"
              :class="[
                'swiper-slide info_btn textfade',
                { textfade3: activeSec > 3 },
              ]"
            >
              <div class="top">
                <img
                  :src="require(`@/assets/image/home/v2/mobile/${item.img}.png`)"
                  alt=""
                />
                <span>{{ item.title }}</span>
              </div>
              <div class="bottom">
                <div
                  :class="['subtitle textfade', { textfade4: activeSec > 3 }]"
                >
                  <h5>{{ adhibition[activeCase].subtitle }}</h5>
                  <span @click="changeRoute('/service')">查看详情 ></span>
                </div>
                <ul :class="['list textfade', { textfade5: activeSec > 3 }]">
                  <li
                    v-for="(el, idx) in item.content"
                    :key="idx"
                  >
                    <h6>{{ el.caption }}</h6>
                    <p v-html="el.matter"></p>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div class="line">
          <span
            :key="index"
            v-for="(i, index) in [...Array(5)]"
            :class="{ active: activeCase === index }"
          ></span>
        </div>
      </template>
    </section>
    <foot class="seventh"></foot>
  </div>
</template>

<script>
import { isMobile } from "@/js/utils";
import { mapState, mapMutations } from "vuex";
import { feature, adhibition } from "@/assets/data/home";
import Swiper from "swiper";
import "swiper/css/swiper.min.css";

export default {
  name: "home",
  components: {
    Foot: () => import("@/components/footer.vue"),
  },
  data() {
    return {
      isMobile: false,
      activeSec: 1,
      heights: {
        h1: 0,
        h2: 0,
        h3: 0,
        h4: 0,
      },

      hasBg: false,
      feature,
      adhibition,
      activeCase: 0,
      swiperFadeType: "",
    };
  },

  computed: {
    ...mapState(["headerStyle"]),
    text() {
      return this.$route.params.lang === "CN" ? home.CN : home.EN;
    },
  },

  watch: {
    $route(val) {},
  },

  methods: {
    ...mapMutations(["setHeaderStyle"]),

    scrollEvent() {
      let { h1, h2, h3, h4 } = this.heights;
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let r = 0.4;
      if (scrollTop > h1 * r && this.activeSec < 2) {
        this.activeSec = 2;
      }
      if (scrollTop > h1 + h2 * r && this.activeSec < 4) {
        this.activeSec = 3;
      }
      if (scrollTop > h1 + h2 + h3 * r && this.activeSec < 4) {
        this.activeSec = 4;
      }
    },

    getHeights() {
      this.heights = {
        h1: this.$refs.sec1.offsetHeight,
        h2: this.$refs.sec2.offsetHeight,
        h3: this.$refs.sec3.offsetHeight,
        h4: this.$refs.sec4.offsetHeight,
      };
    },

    handleFeature(index) {
      switch (index) {
        case 0:
          window.open("https://www.airspace.cn/", "_blank");
          break;

        case 1:
          document.documentElement.scrollTop =
            this.heights.h1 + this.heights.h2;
          break;
        case 2:
          document.documentElement.scrollTop =
            this.heights.h1 + this.heights.h2 + this.heights.h3;
          break;

        default:
          break;
      }
    },

    changeRoute(path) {
      this.$router.push(`/${this.$route.params.lang}${path}`);
    },

    initSwiper() {
      let self = this;
      this.$nextTick(() => {
        const slideElement = document.getElementById("slide");
        if (!slideElement) {
          console.error("Slide element not found");
          return;
        }
        
        let width = slideElement.offsetWidth;
        new Swiper(".swiper-container", {
          width: Number(width),
          centeredSlides: true,
          slidesPerView: 1,
          // loop: true,
          on: {
            slideChangeTransitionEnd: function () {
              // 使用this关键字引用Swiper实例，避免参数传递问题
              if (this.realIndex !== undefined) {
                self.activeCase = this.realIndex;
              } else if (this.activeIndex !== undefined) {
                // 备用方案：使用activeIndex
                self.activeCase = this.activeIndex % self.adhibition.length;
              }
            }
          }
        });
      });
    },
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollEvent);
    window.removeEventListener("resize", this.resize);
  },

  mounted() {
    this.isMobile = window.innerWidth <= 600 || isMobile();
    this.setHeaderStyle({ headerStyle: "light" });
    this.$nextTick(() => {
      this.hasBg = true;
      if (this.isMobile) {
        this.initSwiper();
        // } else {
        //   this.initChart();
      }
      setTimeout(() => {
        this.getHeights();
      }, 500);
      window.addEventListener("scroll", this.scrollEvent);
      window.addEventListener("resize", this.resize);
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/css/home.scss";
</style>
